var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("De")]),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { config: _vm.datePickerConfig },
                  on: { "dp-change": _vm.changeData },
                  model: {
                    value: _vm.fromDate,
                    callback: function($$v) {
                      _vm.fromDate = $$v
                    },
                    expression: "fromDate"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("Até")]),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { config: _vm.datePickerConfig },
                  on: { "dp-change": _vm.changeData },
                  model: {
                    value: _vm.toDate,
                    callback: function($$v) {
                      _vm.toDate = $$v
                    },
                    expression: "toDate"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Ordenar por")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ordenacao,
                      expression: "ordenacao"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { name: "", id: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.ordenacao = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "quantidade" } }, [
                    _vm._v("Quantidade")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "codigo" } }, [
                    _vm._v("Código")
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Ordem")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ordem,
                      expression: "ordem"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { name: "", id: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.ordem = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "asc" } }, [
                    _vm._v("Crescente")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "desc" } }, [
                    _vm._v("Decrescente")
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 printer" }, [
        _c("table", { staticClass: "table table-striped" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.orderedEstoques, function(estoque, index) {
              return _c("tr", { staticClass: "text-center" }, [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(estoque.codigo))]),
                _vm._v(" "),
                _c("td", { staticClass: "text-left" }, [
                  _vm._v(_vm._s(estoque.produto))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(estoque.quantidade))])
              ])
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left" }, [_vm._v("Produto")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Aproveitamento")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-346868f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-346868f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_ranking/Estoque.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-346868f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_ranking/Estoque.vue
// module chunks = 2